import * as React from 'react';
import { useItineraries } from './useItineraries';

export const ItineraryRebaser = ({ digitalMapId }: { digitalMapId: string }) => {
  const { rebaseItineraries } = useItineraries();

  React.useEffect(() => {
    if (!digitalMapId) return;

    try {
      rebaseItineraries(digitalMapId);
    } catch (error) {
      console.error('Error rebasing itineraries:', error);
    }
  }, [digitalMapId, rebaseItineraries]);

  return null;
};
